import { useState } from "react";

const FOODS = [
  { id: "paneer", name: "Paneer", protein: 18, cal: 265, unit: "gm", icon: "🧈", type: "veg", desc: "Cottage cheese" },
  { id: "chana", name: "Chickpeas", protein: 19, cal: 164, unit: "gm", icon: "svg:chickpeas", type: "veg", desc: "Chana" },
  { id: "moong", name: "Moong Dal", protein: 24, cal: 347, unit: "gm", icon: "svg:moongdal", type: "veg", desc: "Green gram lentil" },
  { id: "toor", name: "Toor Dal", protein: 22, cal: 343, unit: "gm", icon: "svg:toordal", type: "veg", desc: "Pigeon pea lentil" },
  { id: "rajmah", name: "Rajma", protein: 8.7, cal: 127, unit: "gm", icon: "🫘", type: "veg", desc: "Kidney beans" },
  { id: "soybean", name: "Soyabean", protein: 36, cal: 446, unit: "gm", icon: "🫛", type: "veg", desc: "Plant powerhouse" },
  { id: "tofu", name: "Tofu", protein: 8, cal: 76, unit: "gm", icon: "svg:tofu", type: "veg", desc: "Soy curd" },
  { id: "peanut", name: "Peanuts", protein: 26, cal: 567, unit: "gm", icon: "🥜", type: "veg", desc: "Roasted groundnuts" },
  { id: "milk", name: "Milk", protein: 3.4, cal: 61, unit: "ml", icon: "🥛", type: "veg", desc: "Full cream" },
  { id: "curd", name: "Greek Yogurt", protein: 10, cal: 59, unit: "gm", icon: "🍶", type: "veg", desc: "High-protein curd" },
  { id: "oats", name: "Oats", protein: 13, cal: 389, unit: "gm", icon: "🌾", type: "veg", desc: "Whole grain" },
  { id: "sprouts", name: "Sprouts", protein: 24, cal: 347, unit: "gm", icon: "🌱", type: "veg", desc: "Moong sprouts" },
  { id: "egg", name: "Egg", protein: 6.3, cal: 78, unit: "nos", icon: "🥚", type: "nonveg", desc: "~6.3g each", isEgg: true },
  { id: "chicken", name: "Chicken Breast", protein: 31, cal: 165, unit: "gm", icon: "🍗", type: "nonveg", desc: "Lean & loaded" },
  { id: "fish", name: "Fish (Rohu)", protein: 17, cal: 97, unit: "gm", icon: "🐟", type: "nonveg", desc: "River fish" },
  { id: "shrimp", name: "Prawns", protein: 24, cal: 99, unit: "gm", icon: "🦐", type: "nonveg", desc: "Shellfish" },
  { id: "mutton", name: "Mutton", protein: 25, cal: 294, unit: "gm", icon: "🥩", type: "nonveg", desc: "Goat meat" },
  { id: "tuna", name: "Tuna", protein: 29, cal: 132, unit: "gm", icon: "🐠", type: "nonveg", desc: "Canned or fresh" },
];

const ACTIVITY = [
  { key: "sedentary", label: "Light", mult: 0.8, emoji: "🪑", desc: "Desk job" },
  { key: "moderate", label: "Moderate", mult: 1.0, emoji: "🚶", desc: "3-4x/week" },
  { key: "active", label: "Active", mult: 1.2, emoji: "🏃", desc: "Daily exercise" },
  { key: "athlete", label: "Intense", mult: 1.6, emoji: "🏋️", desc: "Heavy training" },
];

function calcAmount(food, protein) {
  if (food.isEgg) return Math.ceil(protein / food.protein);
  return Math.round((protein / food.protein) * 100);
}
function calcCalories(food, protein) {
  if (food.isEgg) return Math.round(calcAmount(food, protein) * food.cal);
  const grams = (protein / food.protein) * 100;
  return Math.round((grams / 100) * food.cal);
}
function fmt(food, protein) {
  const a = calcAmount(food, protein);
  if (food.isEgg) return a;
  if (a >= 1000) return `${(a / 1000).toFixed(1)}kg`;
  return `${a}`;
}
function unitLabel(food, protein) {
  if (food.isEgg) return calcAmount(food, protein) === 1 ? "egg" : "eggs";
  return food.unit;
}

/* ── CUTE CUSTOM FOOD ICONS ── */
function ChickpeasIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36">
      {/* Three cute round chickpeas */}
      <circle cx="12" cy="20" r="7" fill="#F0C75E"/>
      <circle cx="12" cy="20" r="7" fill="url(#cpShine)" />
      <path d="M9 17c1.5-1 4.5-1 6 0" stroke="#D4A843" strokeWidth="1" fill="none" strokeLinecap="round"/>
      <circle cx="10" cy="18.5" r="0.7" fill="#D4A843" opacity="0.4"/>

      <circle cx="24" cy="18" r="6.5" fill="#EDBE4A"/>
      <circle cx="24" cy="18" r="6.5" fill="url(#cpShine2)" />
      <path d="M21.5 15.5c1.2-0.8 3.8-0.8 5 0" stroke="#CDA23E" strokeWidth="1" fill="none" strokeLinecap="round"/>
      <circle cx="22.5" cy="16.5" r="0.6" fill="#CDA23E" opacity="0.4"/>

      <circle cx="18" cy="10" r="5.5" fill="#F2D06B"/>
      <circle cx="18" cy="10" r="5.5" fill="url(#cpShine3)" />
      <path d="M16 8c1-0.7 3-0.7 4 0" stroke="#D4A843" strokeWidth="0.8" fill="none" strokeLinecap="round"/>

      {/* Cute eyes on front chickpea */}
      <circle cx="10.5" cy="21" r="1" fill="#5C3D2E"/>
      <circle cx="14" cy="21" r="1" fill="#5C3D2E"/>
      <circle cx="10.8" cy="20.6" r="0.4" fill="white"/>
      <circle cx="14.3" cy="20.6" r="0.4" fill="white"/>
      <path d="M11 23.5c0.5 0.5 1.5 0.5 2 0" stroke="#5C3D2E" strokeWidth="0.6" fill="none" strokeLinecap="round"/>

      <defs>
        <radialGradient id="cpShine" cx="0.35" cy="0.35"><stop offset="0%" stopColor="white" stopOpacity="0.35"/><stop offset="100%" stopColor="white" stopOpacity="0"/></radialGradient>
        <radialGradient id="cpShine2" cx="0.35" cy="0.35"><stop offset="0%" stopColor="white" stopOpacity="0.3"/><stop offset="100%" stopColor="white" stopOpacity="0"/></radialGradient>
        <radialGradient id="cpShine3" cx="0.35" cy="0.35"><stop offset="0%" stopColor="white" stopOpacity="0.3"/><stop offset="100%" stopColor="white" stopOpacity="0"/></radialGradient>
      </defs>
    </svg>
  );
}

function MoongDalIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36">
      {/* Bowl */}
      <ellipse cx="18" cy="24" rx="14" ry="4" fill="#C67B3C"/>
      <path d="M4 20c0 6 6.5 11 14 11s14-5 14-11H4z" fill="#D4884A"/>
      <ellipse cx="18" cy="20" rx="14" ry="4.5" fill="#E09B5C"/>
      {/* Dal soup */}
      <ellipse cx="18" cy="20" rx="12" ry="3.5" fill="#F5C94A"/>
      <ellipse cx="18" cy="19.5" rx="12" ry="3" fill="#F7D76B"/>
      {/* Steam */}
      <path d="M12 13c0-2 1.5-3 1.5-5" stroke="#E09B5C" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.5"/>
      <path d="M18 12c0-2 1.5-3 1.5-5" stroke="#E09B5C" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.5"/>
      <path d="M24 13c0-2 1.5-3 1.5-5" stroke="#E09B5C" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.5"/>
      {/* Cute face */}
      <circle cx="14" cy="19.5" r="1" fill="#5C3D2E"/>
      <circle cx="22" cy="19.5" r="1" fill="#5C3D2E"/>
      <circle cx="14.3" cy="19.1" r="0.4" fill="white"/>
      <circle cx="22.3" cy="19.1" r="0.4" fill="white"/>
      <path d="M16 22c1 0.8 3 0.8 4 0" stroke="#5C3D2E" strokeWidth="0.7" fill="none" strokeLinecap="round"/>
      {/* Tadka dots */}
      <circle cx="10" cy="18" r="0.8" fill="#E07B3C" opacity="0.6"/>
      <circle cx="26" cy="18.5" r="0.6" fill="#E07B3C" opacity="0.5"/>
      {/* Shine */}
      <ellipse cx="15" cy="18" rx="3" ry="1" fill="white" opacity="0.15"/>
    </svg>
  );
}

function ToorDalIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36">
      {/* Bowl */}
      <ellipse cx="18" cy="24" rx="14" ry="4" fill="#A0522D"/>
      <path d="M4 20c0 6 6.5 11 14 11s14-5 14-11H4z" fill="#B8673A"/>
      <ellipse cx="18" cy="20" rx="14" ry="4.5" fill="#CB7B4A"/>
      {/* Dal - slightly more orange than moong */}
      <ellipse cx="18" cy="20" rx="12" ry="3.5" fill="#F0A830"/>
      <ellipse cx="18" cy="19.5" rx="12" ry="3" fill="#F5BE50"/>
      {/* Steam */}
      <path d="M13 13c0.5-1.5 0-3 1-5" stroke="#CB7B4A" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.45"/>
      <path d="M23 12.5c0.5-1.5 0-3 1-5" stroke="#CB7B4A" strokeWidth="1" strokeLinecap="round" fill="none" opacity="0.45"/>
      {/* Cute face — sleepy/happy */}
      <path d="M13 19c0.8-0.5 1.5-0.5 2.3 0" stroke="#5C3D2E" strokeWidth="0.9" fill="none" strokeLinecap="round"/>
      <path d="M20.7 19c0.8-0.5 1.5-0.5 2.3 0" stroke="#5C3D2E" strokeWidth="0.9" fill="none" strokeLinecap="round"/>
      <path d="M16 22c1 0.6 3 0.6 4 0" stroke="#5C3D2E" strokeWidth="0.7" fill="none" strokeLinecap="round"/>
      {/* Red chili flake */}
      <circle cx="25" cy="18" r="0.7" fill="#D44" opacity="0.6"/>
      <circle cx="11" cy="19" r="0.5" fill="#D44" opacity="0.4"/>
      {/* Curry leaf */}
      <ellipse cx="9" cy="17.5" rx="1.5" ry="0.7" fill="#6B8E3A" opacity="0.5" transform="rotate(-20 9 17.5)"/>
      <ellipse cx="15" cy="18" rx="3" ry="1" fill="white" opacity="0.12"/>
    </svg>
  );
}

function TofuIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36">
      {/* Tofu block - 3D-ish */}
      <rect x="6" y="14" width="18" height="16" rx="2" fill="#F5F0E0"/>
      <rect x="6" y="14" width="18" height="16" rx="2" fill="url(#tofuShine)"/>
      <polygon points="6,14 12,8 30,8 24,14" fill="#FFF8EC"/>
      <polygon points="24,14 30,8 30,24 24,30" fill="#E8E0CC"/>
      <rect x="6" y="14" width="18" height="16" rx="2" stroke="#E0D8C4" strokeWidth="0.5" fill="none"/>
      {/* Grid lines for tofu texture */}
      <line x1="12" y1="14" x2="12" y2="30" stroke="#E0D8C4" strokeWidth="0.4"/>
      <line x1="18" y1="14" x2="18" y2="30" stroke="#E0D8C4" strokeWidth="0.4"/>
      <line x1="6" y1="20" x2="24" y2="20" stroke="#E0D8C4" strokeWidth="0.4"/>
      <line x1="6" y1="26" x2="24" y2="26" stroke="#E0D8C4" strokeWidth="0.4"/>
      {/* Cute face on front */}
      <circle cx="11" cy="22" r="1" fill="#8B7355"/>
      <circle cx="17" cy="22" r="1" fill="#8B7355"/>
      <circle cx="11.3" cy="21.6" r="0.4" fill="white"/>
      <circle cx="17.3" cy="21.6" r="0.4" fill="white"/>
      <path d="M12.5 24.5c0.8 0.6 2 0.6 2.8 0" stroke="#8B7355" strokeWidth="0.6" fill="none" strokeLinecap="round"/>
      {/* Blush */}
      <circle cx="9.5" cy="23.5" r="1.2" fill="#F5A0A0" opacity="0.2"/>
      <circle cx="18.5" cy="23.5" r="1.2" fill="#F5A0A0" opacity="0.2"/>
      <defs>
        <linearGradient id="tofuShine" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="white" stopOpacity="0.15"/><stop offset="100%" stopColor="white" stopOpacity="0"/></linearGradient>
      </defs>
    </svg>
  );
}

function FoodIcon({ icon }) {
  if (icon === "svg:chickpeas") return <ChickpeasIcon />;
  if (icon === "svg:moongdal") return <MoongDalIcon />;
  if (icon === "svg:toordal") return <ToorDalIcon />;
  if (icon === "svg:tofu") return <TofuIcon />;
  return <span style={{ fontSize: 36, lineHeight: 1 }}>{icon}</span>;
}
const C = {
  bg: "#FFF6ED",
  card: "rgba(255,255,255,0.65)",
  cardBorder: "rgba(220,195,170,0.3)",
  brown: "#5C3D2E",
  brownLight: "#8B6E5A",
  brownMuted: "#B49A87",
  orange: "#E07B3C",
  orangeLight: "#FFF0E3",
  cream: "#FDF3E7",
  text: "#3E2B1E",
  textMuted: "#A08E7E",
  green: "#4CAF6A",
  red: "#E05B5B",
};

function Logo() {
  return (
    <div style={{
      width: 48, height: 48, borderRadius: 14,
      background: "linear-gradient(135deg, #F5A623, #E07B3C)",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 24, lineHeight: 1,
      boxShadow: "0 4px 12px rgba(224,123,60,0.25)",
    }}>
      💪
    </div>
  );
}

function FoodCard({ food, protein, delay }) {
  const amount = fmt(food, protein);
  const unit = unitLabel(food, protein);
  const active = protein > 0;
  const isVeg = food.type === "veg";
  const calories = active ? calcCalories(food, protein) : 0;
  const calDisplay = calories >= 1000 ? `${(calories / 1000).toFixed(1)}k` : calories;

  return (
    <div style={{
      background: C.card,
      backdropFilter: "blur(8px)",
      borderRadius: 18,
      padding: "24px 18px 20px",
      textAlign: "center",
      position: "relative",
      border: `1px solid ${C.cardBorder}`,
      transition: "all 0.3s ease",
      cursor: "default",
      animation: `fadeUp 0.4s ease ${delay}s both`,
    }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 8px 28px rgba(92,61,46,0.08)";
        e.currentTarget.style.borderColor = isVeg ? C.green : C.orange;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.borderColor = C.cardBorder;
      }}
    >
      {/* Veg/Non-veg dot */}
      <div style={{
        position: "absolute", top: 12, right: 12,
        width: 9, height: 9, borderRadius: "50%",
        border: `1.5px solid ${isVeg ? C.green : C.red}`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <div style={{
          width: 4, height: 4, borderRadius: "50%",
          background: isVeg ? C.green : C.red,
        }} />
      </div>

      <div style={{ marginBottom: 8, lineHeight: 1, display: "flex", justifyContent: "center" }}>
        <FoodIcon icon={food.icon} />
      </div>
      <div style={{
        fontSize: 14, fontWeight: 600, color: C.brown, marginBottom: 2,
      }}>{food.name}</div>
      <div style={{
        fontSize: 11, color: C.brownMuted, marginBottom: 14,
      }}>
        {food.protein}g / {food.isEgg ? "egg" : `100${food.unit}`}
      </div>

      {active ? (
        <div style={{
          background: C.orangeLight,
          borderRadius: 12, padding: "12px 10px 9px",
        }}>
          <div style={{
            fontSize: 32, fontWeight: 700,
            color: C.orange,
            lineHeight: 1.1,
          }}>
            {amount}
          </div>
          <div style={{
            fontSize: 11, color: C.brownMuted,
            marginTop: 3, fontWeight: 500,
          }}>
            {unit} / day
          </div>
          <div style={{
            fontSize: 10, color: C.brownMuted,
            marginTop: 4, fontWeight: 500,
            opacity: 0.7,
          }}>
            ≈ {calDisplay} kcal
          </div>
        </div>
      ) : (
        <div style={{ padding: "10px 0 2px" }}>
          <div style={{
            fontSize: 24, fontWeight: 600, color: "#e0d5ca", lineHeight: 1,
          }}>—</div>
        </div>
      )}
    </div>
  );
}

export default function WhatTheWhey() {
  const [weight, setWeight] = useState("");
  const [unitSys, setUnitSys] = useState("kg");
  const [activity, setActivity] = useState("moderate");
  const [filter, setFilter] = useState("all");

  const wKg = unitSys === "kg" ? Number(weight) : Number(weight) * 0.4536;
  const mult = ACTIVITY.find(a => a.key === activity).mult;
  const proteinNeeded = wKg > 0 ? Math.round(wKg * mult) : 0;
  const filtered = filter === "all" ? FOODS : FOODS.filter(f => f.type === filter);

  return (
    <div style={{
      minHeight: "100vh",
      background: `linear-gradient(175deg, ${C.bg} 0%, #FFEED9 40%, #FFF3E4 70%, ${C.bg} 100%)`,
      fontFamily: "'DM Sans', sans-serif",
      color: C.text,
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display&display=swap');

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
        input[type="number"] { -moz-appearance: textfield; }
        .weight-input::placeholder { color: #ddd0c3; }

        @media (max-width: 640px) {
          .activity-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .food-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .input-row { flex-direction: column !important; }
        }
      `}</style>

      <div style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px" }}>

        {/* ── HEADER ── */}
        <header style={{
          paddingTop: 52, paddingBottom: 8,
          animation: "fadeUp 0.5s ease both",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 6 }}>
            <Logo />
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <h1 style={{
                  fontFamily: "'DM Serif Display', Georgia, serif",
                  fontSize: 32, fontWeight: 400, color: C.brown,
                  letterSpacing: "-0.01em",
                }}>
                  What The Whey
                </h1>
                <span style={{ fontSize: 26 }}>💪</span>
              </div>
              <p style={{
                fontSize: 13, color: C.brownMuted, fontWeight: 400,
                fontStyle: "italic", marginTop: 1,
              }}>
                Plan your protein, one meal at a time
              </p>
            </div>
          </div>
          <p style={{
            fontSize: 16, color: C.brownLight, lineHeight: 1.75, maxWidth: 500,
            marginTop: 20,
          }}>
            Know exactly how much of each ingredient you need daily. Once you see the numbers, planning your meals becomes a breeze.
          </p>
        </header>

        {/* ── INPUTS ── */}
        <section style={{
          marginTop: 32,
          animation: "fadeUp 0.5s ease 0.06s both",
        }}>
          <div className="input-row" style={{
            display: "flex", gap: 14, alignItems: "stretch", flexWrap: "wrap",
          }}>
            {/* Weight */}
            <div style={{
              background: C.card,
              backdropFilter: "blur(8px)",
              borderRadius: 18, padding: "22px 26px",
              border: `1px solid ${C.cardBorder}`,
              flex: "1 1 250px",
              display: "flex", flexDirection: "column", gap: 8,
            }}>
              <label style={{
                fontSize: 11, fontWeight: 600, letterSpacing: "0.12em",
                textTransform: "uppercase", color: C.brownMuted,
              }}>Your Weight</label>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <input
                  className="weight-input"
                  type="number" min="20" max="300" placeholder="70"
                  value={weight} onChange={e => setWeight(e.target.value)}
                  style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: 48, fontWeight: 700, color: C.brown,
                    border: "none", outline: "none", width: "100%",
                    background: "transparent",
                  }}
                />
                <div style={{
                  display: "flex", background: C.cream, borderRadius: 12,
                  overflow: "hidden", flexShrink: 0,
                }}>
                  {["kg", "lbs"].map(u => (
                    <button key={u} onClick={() => setUnitSys(u)} style={{
                      padding: "9px 17px", fontSize: 13, fontWeight: 600,
                      fontFamily: "'DM Sans', sans-serif", border: "none", cursor: "pointer",
                      background: unitSys === u ? C.brown : "transparent",
                      color: unitSys === u ? "#fff" : C.brownMuted,
                      transition: "all 0.2s ease", borderRadius: 10,
                    }}>{u}</button>
                  ))}
                </div>
              </div>
            </div>

            {/* Activity */}
            <div style={{
              background: C.card,
              backdropFilter: "blur(8px)",
              borderRadius: 18, padding: "22px 26px",
              border: `1px solid ${C.cardBorder}`,
              flex: "1.5 1 380px",
              display: "flex", flexDirection: "column", gap: 8,
            }}>
              <label style={{
                fontSize: 11, fontWeight: 600, letterSpacing: "0.12em",
                textTransform: "uppercase", color: C.brownMuted,
              }}>Activity Level</label>
              <div className="activity-grid" style={{
                display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8,
              }}>
                {ACTIVITY.map(a => (
                  <button key={a.key} onClick={() => setActivity(a.key)} style={{
                    padding: "14px 6px 10px", borderRadius: 14,
                    border: activity === a.key ? `2px solid ${C.orange}` : `1.5px solid ${C.cardBorder}`,
                    background: activity === a.key ? C.orangeLight : C.card,
                    cursor: "pointer", textAlign: "center", transition: "all 0.2s ease",
                    fontFamily: "'DM Sans', sans-serif",
                  }}>
                    <div style={{ fontSize: 22, marginBottom: 4 }}>{a.emoji}</div>
                    <div style={{
                      fontSize: 12, fontWeight: 600,
                      color: activity === a.key ? C.orange : C.brown,
                    }}>{a.label}</div>
                    <div style={{
                      fontSize: 10, color: activity === a.key ? C.brownMuted : "#c4b5a3", marginTop: 1,
                    }}>{a.desc}</div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ── PROTEIN TARGET ── */}
        {proteinNeeded > 0 && (
          <div style={{
            marginTop: 16,
            background: C.card,
            backdropFilter: "blur(8px)",
            borderRadius: 16,
            padding: "20px 28px",
            border: `1px solid ${C.cardBorder}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            gap: 10, flexWrap: "wrap",
            animation: "fadeUp 0.35s ease both",
          }}>
            <span style={{ fontSize: 22 }}>🎯</span>
            <span style={{ fontSize: 15, color: C.brownLight, fontWeight: 500 }}>
              Your daily protein target is
            </span>
            <span style={{
              fontFamily: "'DM Serif Display', Georgia, serif",
              fontSize: 32, fontWeight: 400, color: C.orange,
            }}>{proteinNeeded}g</span>
          </div>
        )}

        {/* ── FOOD CARDS ── */}
        <section style={{ marginTop: 40, animation: "fadeUp 0.5s ease 0.12s both" }}>
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            flexWrap: "wrap", gap: 12, marginBottom: 20,
          }}>
            <h2 style={{
              fontFamily: "'DM Serif Display', Georgia, serif",
              fontSize: 24, fontWeight: 400, color: C.brown,
            }}>Pick Your Protein Sources</h2>
            <div style={{
              display: "flex", background: C.card, borderRadius: 12,
              border: `1px solid ${C.cardBorder}`, overflow: "hidden",
            }}>
              {[
                { key: "all", label: "All", emoji: "🍽️" },
                { key: "veg", label: "Veg", emoji: "🌿" },
                { key: "nonveg", label: "Non-Veg", emoji: "🍗" },
              ].map((f, i) => (
                <button key={f.key} onClick={() => setFilter(f.key)} style={{
                  padding: "9px 18px", fontSize: 12, fontWeight: 600,
                  fontFamily: "'DM Sans', sans-serif", border: "none", cursor: "pointer",
                  background: filter === f.key
                    ? (f.key === "veg" ? "#e8f5ea" : f.key === "nonveg" ? C.orangeLight : C.cream)
                    : "transparent",
                  color: filter === f.key
                    ? (f.key === "veg" ? C.green : f.key === "nonveg" ? C.orange : C.brown)
                    : C.brownMuted,
                  transition: "all 0.2s ease",
                  borderRight: i < 2 ? `1px solid ${C.cardBorder}` : "none",
                }}>
                  {f.emoji} {f.label}
                </button>
              ))}
            </div>
          </div>

          {/* Veg */}
          {(filter === "all" || filter === "veg") && (
            <>
              {filter === "all" && (
                <div style={{
                  display: "flex", alignItems: "center", gap: 8,
                  marginBottom: 14, marginTop: 4,
                }}>
                  <div style={{
                    width: 8, height: 8, borderRadius: "50%",
                    background: C.green,
                  }} />
                  <span style={{
                    fontSize: 12, fontWeight: 700, color: C.green,
                    letterSpacing: "0.08em", textTransform: "uppercase",
                  }}>Vegetarian</span>
                  <div style={{ flex: 1, height: 1, background: "rgba(76,175,106,0.15)" }} />
                </div>
              )}
              <div className="food-grid" style={{
                display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12,
              }}>
                {filtered.filter(f => f.type === "veg").map((food, i) => (
                  <FoodCard key={food.id} food={food} protein={proteinNeeded} delay={0.02 * i} />
                ))}
              </div>
            </>
          )}

          {/* Non-veg */}
          {(filter === "all" || filter === "nonveg") && (
            <>
              {filter === "all" && (
                <div style={{
                  display: "flex", alignItems: "center", gap: 8,
                  marginBottom: 14, marginTop: 28,
                }}>
                  <div style={{
                    width: 8, height: 8, borderRadius: "50%",
                    background: C.red,
                  }} />
                  <span style={{
                    fontSize: 12, fontWeight: 700, color: C.red,
                    letterSpacing: "0.08em", textTransform: "uppercase",
                  }}>Non-Vegetarian</span>
                  <div style={{ flex: 1, height: 1, background: "rgba(224,91,91,0.15)" }} />
                </div>
              )}
              <div className="food-grid" style={{
                display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12,
              }}>
                {filtered.filter(f => f.type === "nonveg").map((food, i) => (
                  <FoodCard key={food.id} food={food} protein={proteinNeeded} delay={0.02 * i} />
                ))}
              </div>
            </>
          )}
        </section>

        {/* ── TIP ── */}
        <section style={{
          marginTop: 40, paddingBottom: 64,
          animation: "fadeUp 0.5s ease 0.2s both",
        }}>
          <div style={{
            background: C.card,
            backdropFilter: "blur(8px)",
            borderRadius: 18, padding: "24px 26px",
            border: `1px solid ${C.cardBorder}`,
          }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
              <span style={{ fontSize: 22, lineHeight: 1, flexShrink: 0, marginTop: 2 }}>💡</span>
              <div>
                <h3 style={{
                  fontFamily: "'DM Serif Display', Georgia, serif",
                  fontSize: 16, fontWeight: 400, color: C.brown, marginBottom: 6,
                }}>How to use this</h3>
                <p style={{ fontSize: 13, color: C.brownLight, lineHeight: 1.8 }}>
                  Each card shows how much of that <em>one</em> food covers your full daily protein.
                  In reality, mix sources — two eggs for breakfast, dal for lunch, paneer for dinner —
                  and the numbers add up naturally. Use these as building blocks to plan your meals.
                </p>
              </div>
            </div>
          </div>

          <p style={{
            marginTop: 24, fontSize: 11, color: C.brownMuted,
            textAlign: "center", lineHeight: 1.7,
          }}>
            Based on RDA guidelines ({mult}g protein / kg body weight).
            Consult a nutritionist for personalized advice.
          </p>

          <div style={{
            marginTop: 12, textAlign: "center",
            fontSize: 11, color: C.brownMuted,
          }}>
            Made with ❤️ by <strong style={{ color: C.brownLight }}>Karthika</strong>
          </div>
        </section>
      </div>
    </div>
  );
}
